const tracksFR = {
    "view": {
        "table": {
            "title": "Modifier les pistes",
            "column": {
                "name": "Nom",
                "mixName": "Nom du Mix",
                "mixLength": "Durée du Mix",
                "player": "Lecteur",
                "status": "Statut",
                "accStatus": "Statut Acc",
                "qc": "QC",
                "action": "Action"
            },
            "button": {
                "edit": "Modifier",
                "goToReleases": "Aller aux sorties",
                "distribute": "Distribuer",
                "submitEditing": "Soumettre la modification",
                "statusReady": "Prêt",
                "statusNotReady": "Pas prêt"
            },
            "message": {
                "identityNotCheckedTooltip": "Vous n'avez pas encore fourni vos informations complètes, par conséquent, vous ne pouvez pas distribuer les sorties. Pour ce faire, veuillez soumettre vos informations.",
                "tracksNotReadyTooltip": "Veuillez soumettre les métadonnées pour toutes les pistes afin de distribuer la sortie.",
                "tracksNotReadyForEditingTooltip": "Veuillez soumettre les métadonnées pour toutes les pistes, afin de soumettre les modifications.",
                "distributionDisabledPreScanInProgressTooltip": "Veuillez attendre que le pré-scan soit terminé avant de distribuer la sortie.",
                "distributionDisabledPreScanNotDoneTooltip": "Veuillez effectuer le pré-scan avant de distribuer la sortie.",
                "distributionDisabledPreScanDeclarationNotSubmittedTooltip": "Veuillez soumettre la déclaration du pré-scan avant de distribuer la sortie.",
                "browserNotSupported": "Votre navigateur ne supporte pas l'élément audio.",
                "trackUpdated": "La piste a été mise à jour !"
            },
            "modal": {
                "distribute": {
                    "header": "Êtes-vous sûr que toutes les informations saisies sont valides et représentent pleinement cette sortie ?",
                    "body": {
                        "point1": "Après cette action, votre sortie sera vérifiée et si les informations sont correctes, elle sera distribuée aux dates de distribution officielles et exclusives.",
                        "point2": "En confirmant et en acceptant ce formulaire, vous acceptez pleinement et vous conformez aux <1>Conditions de Distribution</1>, <3>Conditions d'Utilisation</3> et <5>Politique de Confidentialité</5>.",
                        "point3": "En confirmant et en acceptant ce formulaire, vous confirmez indiscutablement que le contenu soumis avec les actifs associés, les fichiers audio et les métadonnées, vous appartient exclusivement ou est entièrement licencié à votre label.",
                        "point4": "Par la présente, vous acceptez pleinement d'être seul responsable de toute information trompeuse, utilisation non autorisée, activité illégale ou tout type de litige.",
                        "flaggedTracksTerms": {
                            "header": "Conditions des pistes signalées",
                            "point1": "Veuillez noter : <strong>'{{releaseName}}'</strong> contient une ou plusieurs pistes signalées, des frais de <strong>15 €</strong> par piste signalée s'appliquent pour livrer la sortie à <strong>Spotify</strong>. Comme vous avez choisi de ne pas payer ces frais pour le moment, la sortie ne sera pas livrée à Spotify. En confirmant et en acceptant ce formulaire, vous reconnaissez et acceptez ces conditions.",
                            "point2": "À l'avenir, si vous choisissez de livrer la sortie à <strong>Spotify</strong>, vous pouvez aller à la section Signalée dans le tableau des sorties et suivre les instructions de paiement."
                        },
                        "artificialStreamingDeclaration": {
                            "header": "Déclaration de Streaming Artificiel",
                            "point1": "<strong>1.</strong> Je comprends et accepte pleinement de ne pas m'engager dans toute forme de streaming artificiel, y compris l'utilisation de bots, de fermes de streaming ou de toute méthode qui manipule les métriques DSP.",
                            "point2": "<strong>2.</strong> Je ne paierai pas ou n'offrirai pas de paiement pour des placements dans des playlists, ni ne travaillerai avec un tiers promettant des placements garantis — je comprends que cela est considéré comme une fraude et une escroquerie.",
                            "point3": "<strong>3.</strong> Je reconnais que de telles actions peuvent entraîner une résiliation immédiate, la perte de redevances, des réclamations légales, des pénalités contractuelles et des frais, et un signalement aux DSP et aux autorités.",
                            "point4": "<strong>4.</strong> Je garantis également d'informer et d'éduquer tous les artistes ou clients avec lesquels je travaille sur ces règles et de m'assurer qu'ils s'y conforment.",
                            "point5": "<strong>5.</strong> Je comprends que si je m'engage dans le streaming artificiel, mes données KYC, y compris mon nom complet, adresse, carte d'identité et autres informations personnelles, peuvent être partagées avec les départements juridiques des DSP, tels que ceux de Spotify, Apple Music et d'autres.",
                            "point6": "<strong>6.</strong> J'accepte l'entière responsabilité légale de toute violation.",
                            "acknowledgment": "Je reconnais par la présente et accepte de respecter les termes ci-dessus du Streaming Artificiel, et j'accepte l'entière responsabilité légale de toute violation."
                        }
                    },
                    "button": {
                        "cancel": "Annuler",
                        "confirm": "Confirmer et accepter"
                    }
                },
                "finishEditing": {
                    "header": "Êtes-vous sûr que toutes les informations saisies sont valides et représentent pleinement cette sortie ?",
                    "body": {
                        "point1": "Après cette action, votre sortie sera vérifiée et si les informations sont correctes, elle sera redistribuée aux partenaires DSP. <strong>REMARQUE, seules les MÉTADONNÉES seront envoyées aux DSP, le contenu tel que les fichiers IMAGE et AUDIO ne peut pas être mis à jour de cette manière.</strong>",
                        "point2": "En confirmant et en acceptant ce formulaire, vous acceptez pleinement et vous conformez aux <1>Conditions d'Utilisation</1> et aux termes de notre Accord de Distribution Exclusive.",
                        "point3": "En confirmant et en acceptant ce formulaire, vous acceptez pleinement et vous conformez à la <1>Politique de Confidentialité</1>.",
                        "point4": "En confirmant et en acceptant ce formulaire, vous confirmez indiscutablement que le contenu soumis avec les actifs associés, les fichiers audio et les métadonnées, vous appartient exclusivement ou est entièrement licencié à votre label.",
                        "point5": "Par la présente, vous acceptez pleinement d'être seul responsable de toute information trompeuse, utilisation non autorisée, activité illégale ou tout type de litige."
                    },
                    "button": {
                        "cancel": "Annuler",
                        "confirm": "Confirmer et accepter"
                    }
                }
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "title": "Modifier la piste {{trackName}}",
                "mandatoryMetadata": "Métadonnées obligatoires",
                "required": "Requis",
                "trackName": "Nom de la piste",
                "mixName": "Nom du Mix",
                "originalmix": "Mix Original",
                "remix": "Ceci est un Remix ou Mix",
                "vocals": "Voix",
                "genre": "Genre",
                "subGenre": "Sous-Genre",
                "additionalMetadata": "Métadonnées supplémentaires",
                "copyright": "Droits d'auteur ©",
                "copyrightYear": "Année des droits d'auteur",
                "albumOnly": "Album uniquement",
                "explicitContent": "Contenu explicite",
                "isrc": "ISRC",
                "daIsrc": "Dolby Atmos ISRC",
                "generateIsrc": "Générer ISRC",
                "trackLanguageMetadata": "Métadonnées de langue de la piste",
                "language": "Langue",
                "autoDetectLanguage": "Détection automatique (Langue)",
                "accountingData": "Données comptables",
                "labelShare": "Part du label (%)"
            },
            "placeholder": {
                "select": "Sélectionner...",
                "labelShare": "c'est-à-dire 50"
            },
            "help_text": {
                "trackName": "Titre de la piste",
                "mixName": "Insérez le nom du mix sans parenthèses. Certaines pistes sont publiées en plusieurs versions. Ce champ décrit la version, par exemple 'Bunte Bummler - Aesub (Monika Ross Remix)",
                "vocals": "Écoutez votre piste en entier. Si votre piste contient des voix, veuillez sélectionner la langue des voix. Si votre piste est sans voix, sélectionnez l'option Instrumental. Vérifiez-le deux fois pour être sûr. Si cette entrée est incorrecte, certains magasins comme iTunes et Apple Music rejetteront la sortie.",
                "publishers": {
                    "publisherName": "<strong>Nom de l'éditeur :</strong> Veuillez insérer le nom complet de la société d'édition si vous utilisez des services d'édition. Si vous n'utilisez pas de services d'édition officiels, veuillez insérer/sélectionner <strong>Contrôle des droits d'auteur</strong>. Veuillez <strong>ne pas insérer le nom de votre label</strong> s'il ne s'agit pas d'une société d'édition enregistrée. Des implications légales peuvent s'appliquer.",
                    "authorSongWriterName": "<strong>Nom complet de l'auteur / compositeur :</strong> Veuillez insérer le <strong>prénom et le nom réels</strong> de la personne."
                },
                "contributors": {
                    "contributorsName": "<strong>Nom des contributeurs :</strong> Veuillez insérer le <strong>prénom et le nom réels</strong> de la personne.",
                    "contributorsRoles": "<strong>Rôles des contributeurs :</strong> Au moins un contributeur doit être ajouté en tant que <strong>Compositeur</strong>. Si votre piste contient des voix, au moins un contributeur doit être ajouté en tant que <strong>Compositeur</strong> et un contributeur doit être ajouté en tant que <strong>Parolier</strong>."
                },
                "copyright": "Nom du titulaire des droits d'auteur",
                "albumOnly": "Indique si la piste sera vendue uniquement dans le cadre d'une sortie groupée. Notez que certains magasins peuvent ignorer cette instruction",
                "explicitContent": "Veuillez marquer ce champ si la piste contient des paroles interdites",
                "isrc": "Le Code International Normalisé des Enregistrements attribué à la piste. Si vous n'en avez pas, nous en générerons un pour vous",
                "daIsrc": "Le Code International Normalisé des Enregistrements attribué à la piste. Si vous n'en avez pas, nous en générerons un pour vous",
                "language": "Dans quelle langue le nom de la piste est-il écrit ? Veuillez vérifier deux fois si vous n'êtes pas sûr. Si cette entrée est incorrecte, certains magasins comme iTunes et Apple Music rejetteront la sortie.",
                "labelShare": "<strong>Conseil :</strong> La norme de l'industrie pour la <strong>part du label</strong> est de <strong>50%</strong> et de <strong>50%</strong> pour les <strong>actionnaires</strong>. Nous vous conseillons fortement d'insérer le pourcentage de partage exact sur lequel vous vous êtes mis d'accord avec vos artistes, actionnaires et partenaires.",
                "costTypes": {
                    "point1": "Insérez uniquement les <strong>coûts</strong> réels, survenus ou préalablement convenus par piste. Nous vous conseillons fortement de ne pas insérer de faux coûts.",
                    "point2": "<strong>Types de coûts</strong> peuvent être des coûts fixes ou variables, c'est-à-dire <strong>Mastering Audio, Design Graphique, Promotion, Marketing</strong>, ou toute autre dépense viable engagée pour la <strong>Piste</strong> par le <strong>Label</strong>."
                }
            },
            "button": {
                "submitTrack": "Soumettre la piste"
            },
            "message": {
                "successArtistAdded": "Un nouvel artiste a été ajouté !",
                "successPublisherAdded": "Un nouvel éditeur a été ajouté !",
                "successContributorAdded": "Un nouveau contributeur a été ajouté !",
                "successShareholderAdded": "Un nouvel actionnaire a été ajouté !",
                "successCostTypeAdded": "Un nouveau type de coût a été ajouté !",
                "errorLabelShareInvalid": "Veuillez entrer une valeur valide (1-100)",
                "errorFormCannotBeSubmitted": "Le formulaire ne peut pas être soumis ! Veuillez remplir tous les champs et vérifier les erreurs !",
                "accountingMetadata": {
                    "title": "AVERTISSEMENT",
                    "description": {
                        "point1": "MÉTADONNÉES OPTIONNELLES - remplissez cette partie des métadonnées uniquement si vous émettez des rapports comptables à vos artistes ou actionnaires !",
                        "point2": "Veuillez vous assurer que les données soumises dans cette section sont entièrement exactes, car elles affecteront les rapports que vous enverrez à vos artistes et actionnaires.",
                        "point3": "Nous vous recommandons fortement de vérifier deux fois les entrées car après la soumission, des modifications et des changements supplémentaires ne sont pas recommandés pour des raisons de précision des données.",
                        "point4": "Les rapports comptables pour vos artistes et actionnaires auront un effet précis uniquement si vous soumettez tous les paramètres correctement et selon vos accords avec vos artistes et actionnaires.",
                        "point5": "Les coûts ne peuvent être ajoutés qu'une seule fois et ne peuvent pas être modifiés par la suite pour des raisons de transparence et de précision. Assurez-vous d'insérer tous les coûts de piste avec précision dès votre première tentative."
                    }
                }
            }
        }
    },
    "publishersRow": {
        "form": {
            "label": {
                "publishers": "Éditeurs",
                "required": "Requis",
                "order": "Ordre",
                "publisherName": "Nom de l'éditeur",
                "authorSongWriterName": "Nom complet de l'auteur / compositeur"
            },
            "placeholder": {
                "publisherName": "Sélectionner l'éditeur..."
            },
            "button": {
                "addAnother": "Ajouter un autre",
                "createNew": "Créer nouveau ?",
                "remove": "Supprimer"
            },
            "message": {
                "publisherRequired": "Veuillez sélectionner un éditeur",
                "authorSongWriterRequired": "Veuillez insérer le prénom et le nom réels de la personne."
            },
            "modal": {
                "header": "Ajouter un nouvel éditeur",
                "body": {
                    "label": {
                        "name": "Nom"
                    },
                    "message": {
                        "nameRequired": "Le nom est requis",
                        "publisherAlreadyExists": "L'éditeur existe déjà"
                    }
                },
                "button": {
                    "createNew": "Créer nouveau",
                    "cancel": "Annuler"
                }
            }
        }
    },
    "contributorsRow": {
        "form": {
            "label": {
                "contributors": "Contributeurs",
                "required": "Requis",
                "order": "Ordre",
                "contributorName": "Nom complet du contributeur",
                "contributorRole": "Rôle du contributeur"
            },
            "placeholder": {
                "contributorName": "Sélectionner le contributeur..."
            },
            "button": {
                "addAnother": "Ajouter un autre",
                "createNew": "Créer nouveau ?",
                "remove": "Supprimer"
            },
            "modal": {
                "header": "Ajouter un nouveau contributeur",
                "body": {
                    "label": {
                        "name": "Nom"
                    },
                    "help_text": {
                        "name": "Veuillez insérer le prénom et le nom complets du compositeur. Exemple : 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Le nom est requis",
                        "nameMustNotBeInUppercase": "Le nom ne doit pas être en majuscules",
                        "insertRealName": "Veuillez insérer le prénom et le nom réels de la personne.",
                        "errorContributorAlreadyExists": "Le contributeur existe déjà"
                    }
                },
                "button": {
                    "createNew": "Créer nouveau",
                    "cancel": "Annuler"
                }
            }
        }
    },
    "shareholdersRow": {
        "form": {
            "label": {
                "order": "Ordre",
                "shareholders": "Actionnaires",
                "shareholderName": "Nom de l'actionnaire",
                "shareholderSplit": "Part de l'actionnaire (%)",
                "shareholderRoles": "Rôles de l'actionnaire"
            },
            "placeholder": {
                "shareholderName": "Sélectionner l'actionnaire...",
                "shareholderSplit": "c'est-à-dire 50"
            },
            "message": {
                "shareholderRequired": "Veuillez sélectionner un actionnaire",
                "shareholderSplitRequired": "Veuillez entrer une valeur valide (1-100)",
                "shareholderRolesRequired": "Veuillez sélectionner au moins un rôle",
                "shareSum": "La part du label et les parts des actionnaires doivent totaliser 100%"
            },
            "button": {
                "addAnother": "Ajouter un autre",
                "createNew": "Créer nouveau ?",
                "remove": "Supprimer"
            },
            "modal": {
                "header": "Ajouter un nouvel actionnaire",
                "body": {
                    "label": {
                        "name": "Nom",
                        "email": "Email"
                    },
                    "help_text": {
                        "name": "Veuillez insérer le prénom et le nom complets du compositeur. Exemple : 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Le nom est requis",
                        "emailRequired": "L'email est requis",
                        "emailInvalid": "L'email n'est pas valide"
                    }
                },
                "button": {
                    "createNew": "Créer nouveau",
                    "cancel": "Annuler"
                }
            }
        }
    },
    "costTypesRow": {
        "form": {
            "label": {
                "costTypes": "Types de coûts",
                "order": "Ordre",
                "costType": "Type de coût",
                "cost": "Coût (€)"
            },
            "placeholder": {
                "costType": "Sélectionner le type de coût...",
                "cost": "c'est-à-dire -7.5"
            },
            "button": {
                "addAnother": "Ajouter un autre",
                "createNew": "Créer nouveau ?",
                "remove": "Supprimer"
            },
            "message": {
                "costTypeRequired": "Veuillez sélectionner un type de coût",
                "costNotNegative": "Veuillez entrer une valeur négative c'est-à-dire -10.0"
            },
            "modal": {
                "header": "Ajouter un nouveau type de coût",
                "body": {
                    "label": {
                        "name": "Nom"
                    },
                    "message": {
                        "nameRequired": "Le nom est requis",
                        "costTypeAlreadyExists": "Le type de coût existe déjà"
                    },
                    "button": {
                        "createNew": "Créer nouveau",
                        "cancel": "Annuler"
                    }
                }
            }
        }
    }
};

export default tracksFR;